<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section">
              <p class="form-title text-center">
                OREP PROFESSIONAL SERVICES AGREEMENT
              </p>
            </article>
            <article class="input-section form-section">
              <div style="padding-right: 56px;">
                <p class="mb-3">
                  This Professional Services Agreement & Broker Agreement (“Agreement”) is effective as of the date this agreement is signed,
(“Effective Date”), by and between the undersigned (“Client”) and OREP Insurance Services, LLC (“Broker”). Under this Agreement, (a) Client appoints Broker as Client’s insurance broker of record to transact insurance
business on behalf of the Client, and (b) the parties agree to separate services to be provided by Broker to Client and related fees, as
set forth herein.
                </p>
                <p class="mb-3">
                  <strong>Broker of Record: </strong>
                  Client hereby appoints Broker as Client’s insurance broker of record to transact insurance business on behalf of
Client (“Insurance Broking”). When applicable, Broker will make a reasonable search of the marketplace of insurers available to Broker
and provide options to Client for the type of risk that Client wishes to insure based on the requirements and specifications provided by
Client. Because insurance quotations are estimates and subject to change, Client agrees to pay all earned premium and fees charged
on coverage selected. Client acknowledges that no insurance coverage exists until accepted by the carrier(s) and that Broker is not
obligated to change or renew any coverage without a written order. Client authorizes Broker to maintain premium payments in interest
bearing trust accounts and that Broker is entitled to all interest income earned on such funds. Client authorizes Broker to cancel any
insurance policies if any premiums or Service Fees (defined below) remain unpaid to Broker. In addition to the Commission, Client
acknowledges and agrees that Broker may receive additional compensation from insurers, finance companies, or other vendors for its
professional services, which may be in a variety of forms and amounts.
                </p>
                <p class="mb-3">
                  <strong>Scope of Services:</strong>
                  Separate from the Commission, Broker will provide Client services, education, training and other value-add services
(“Services”) in exchange for Client’s payment of the fees (“Service Fees”), as set forth in the below referenced Scope of Services.
Client consents to the payment of the Service Fees. Client acknowledges and agrees that that the Services are separate from the
Insurance Broking and related Commissions, and provide valuable education, information and related services to Client. Client also
acknowledges and agrees that the Service Fees are non-refundable and fully earned upon binding of the insurance policy, irrespective
of whether the policy is later cancelled or non-renewed by Client or insurer. Client further acknowledges and agrees that the Service
Fees are not part of the premium charged by any insurer, and are in addition to Commission paid by Client as well as any additional
compensation Broker may receive from insurers for its professional services.
                </p>
                <p class="mb-3">
                  <strong>General: </strong>
                  This Agreement shall continue in full force until terminated by either party for any reason, and shall terminate when Broker is
no longer Client’s broker of record. This Agreement shall be interpreted and construed in accordance with the laws of California; venue
for any proceeding shall be state/federal courts in California. In any action to enforce this Agreement, the prevailing party shall be
awarded its reasonable attorney’s fees, court or arbitration costs. The Service Fees are applicable as and to the fullest extent
permissible in the applicable state/jurisdiction. If Broker adopts any enhancements to its Services during the term hereof that would
otherwise increase the Services available without additional charge, such increased Services will apply to this Agreement at no extra
charge to Client.
                </p>
                <p class="mb-5">
                  Broker and Client agree to the terms and conditions set forth above and on the attached Scope of Services, and acknowledge receipt of
a copy of this Agreement. Client understands that upon signing this document, the Service Fees will be fully earned by Broker and will
be non-refundable.
                </p>
                <p>
                  <strong>Consent to Electronic Signature: </strong>
                  I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this insurance application. (Please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a> if you do not consent to Electronic Signature.)
                </p>
                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="orep-label m-0">
                      CLIENT
                    </label>
                  </div>
                  <div class="col-md-6">
                    <label class="orep-label m-0">
                      BROKER
                    </label>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Signature:
                    </label>
                    <input
                      type="text"
                      name="clientSignature"
                      class="orep-text-input form-control"
                      v-model="individualAppraiser.clientSignature"
                      v-validate="'required'"
                      placeholder="Type Your Name to Sign"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('clientSignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('clientSignature') | filterText }}</span>
                  </div>
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Signature:
                    </label>
                    <img src="../../../public/assets/images/sign.png" alt="Sign" style="max-height: 40px;">
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Date:
                    </label>
                    <h5 class="m-0">{{formattedCurrentDate()}}</h5>
                  </div>
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Name:
                    </label>
                    <h5 class="m-0">David Brauner</h5>
                  </div>
                </div>
                <div class="row mb-5 justify-content-end">
                  <div class="col-md-offset-6 col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Title:
                    </label>
                    <h5 class="m-0">President</h5>
                  </div>
                </div>
              </div>
            </article>
            <article class="d-flex form-heading title-section form-section">
              <p class="form-title text-center" style="text-decoration: underline;">
                PROFESSIONAL SERVICE AGREEMENT “SCOPE OF SERVICES”
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row table-border" style="margin-right: 56px;">
                <div class="col-md-8">
                  <strong>Services:</strong>
                  <ul>
                    <li>
                      Risk management and loss control information tailored to Real Estate Appraisers,
including zero deductible, FREE approved education, webinars and consulting.
                    </li>
                    <li>
                      Access to coverage hotline handled by experienced staff or consultants who possess
specific knowledge of the Real Estate industry.
                    </li>
                    <li>
                      Access to Real Estate related content, in the form of but not limited to whitepapers,
blogs, podcasts and webinars and Working RE Magazine.
                    </li>
                  </ul>
                </div>
                <div class="col-md-4 d-flex flex-column table-left-border">
                  <strong style="text-decoration: underline">Service / RPG Fee:</strong>
                  <div class="d-flex flex-column justify-content-center flex-grow-1">
                    <strong class="text-decoration-none">Billed Annually: $50</strong>
                    <p>(Replaces $50 OREP fee of prior
years where applicable)</p>
                  </div>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'individual-appraiser-5'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-5')"></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              type="submit"
              :disabled="!state.pageSixIsValid"
              :class="{submitDisabled: !state.pageSixIsValid}"
              class="next-btn mont spaced pull-right"
              @click="formSubmit()"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Submitting the application...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS} from "../../utils/constants";

export default {
  name: "individual-appraiser-6",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    individualAppraiser() {
      return this.$store.state.individualAppraiser.individualAppraiser;
    },
    state() {
      return this.$store.state.individualAppraiser;
    },
    errorMsg() {
      return this.$store.state.individualAppraiser.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageSixIsValid = true;
          return;
        }
        this.state.pageSixIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.individualAppraiser.appraiserEsignatureDatetime).format('MM/DD/YYYY');
    },

    formSubmit() {
      this.loading = true;
      this.state.individualAppraiser.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('individualAppraiser/createIndividualAppraiser');
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  components: {}
};
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .table-left-border {
    border-left: 1px solid black;
  }
  .table-border {
    border: 1px solid black;
  }
</style>

